<template>
  <div class="main_box">
    <div class="main_body">
      <div class="form_bar">
        <div class="form_bar_search">
          <div class="condition_item">
            <span>提交状态：</span>
            <el-select
              v-model="listQuery.SubmitState"
              placeholder="请选择"
              @change="submitStateChange"
            >
              <el-option label="全部" :value="-1"> </el-option>
              <el-option label="未提交" :value="0"> </el-option>
              <el-option label="已提交" :value="1"> </el-option>
            </el-select>
          </div>
        </div>
        <div class="form_bar_btn">
          <el-button type="text" @click="goBack()">返回投票列表</el-button>
          <el-button type="primary" @click="refresh()" size="small" plain>
            刷新
          </el-button>
          <el-button
            type="primary"
            plain
            icon="el-icon-download"
            @click="exportData()"
          >
            导出
          </el-button>
        </div>
      </div>
      <h2 style="text-align: center">
        <div v-html="voteDetail.VoteName + '（明细）'"></div>
      </h2>
      <div class="table-block" style="border-top: 0px">
        <el-table
          border
          :data="voteDetail.Items"
          highlight-current-row
          style="width: 100%"
          :height="tableHeight"
          ref="userTable"
          key="table2"
          :header-cell-class-name="userTableHeaderCellClassName"
          :cell-class-name="userTableCellClassName"
          class="vote_detail_el_table--border"
        >
          <el-table-column
            type="index"
            :index="indexMethod"
            label="序号"
            width="90"
          ></el-table-column>
          <el-table-column
            property="UserName"
            label="投票人"
            width="120"
            align="left"
          >
          </el-table-column>
          <el-table-column
            label="是否提交"
            width="105"
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <div
                style="
                  width: 100%;
                  padding: 0px;
                  margin: 0px;
                  display: -webkit-flex;
                  display: flex;
                  flex-direction: row;
                  justify-content: space-between;
                  align-items: center;
                "
              >
                <span
                  style="color: #409eff"
                  v-if="scope.row.IsSubmit && voteDetail.Status !== 1"
                >
                  已提交
                </span>
                <span
                  style="color: #409eff"
                  v-if="scope.row.IsSubmit && voteDetail.Status === 1"
                >
                  已提交
                </span>
                <i
                  :title="scope.row.SaveTime"
                  class="el-icon-alarm-clock"
                  v-if="scope.row.IsSubmit"
                ></i>
                <span style="color: #e6a23c" v-if="!scope.row.IsSubmit">
                  未提交
                </span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            min-width="210"
            v-for="(col, index) in voteDetail.Columns"
            :property="col.ColumnProp"
            :key="col.ColumnLabel + index"
          >
            <template slot="header">
              <div
                style="
                  display: -webkit-flex;
                  display: flex;
                  flex-direction: row;
                  justify-content: flex-start;
                  align-items: center;
                "
                v-html="col.Sort + '）' + col.ColumnLabel"
              ></div>
            </template>
            <template slot-scope="scope">
              <div
                style="
                  display: -webkit-flex;
                  display: flex;
                  flex-direction: row;
                  justify-content: flex-start;
                  align-items: center;
                "
                v-html="scope.row[scope.column.property]"
              ></div>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination_box">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-sizes="[20, 30, 50, 100, 300, 500, 1000, 5000]"
            :page-size="listQuery.MaxResultCount"
            :layout="pagination_layout"
            :total="listTotalCount"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import voteManageApi from '../../../../../api/vote/voteManage'
export default {
  name: 'Details',
  components: {
  },
  data () {
    return {
      tableHeight: window.innerHeight - 300,
      listQuery: {
        VoteId: null,
        KeyWord: null,
        SkipCount: 0,
        MaxResultCount: 20,
        SubmitState: -1
      },
      listTotalCount: 0,
      currentPage: 1,
      voteDetail: {
        Items: []
      },
      pagination_layout: 'prev, pager, next'
    }
  },
  methods: {
    goBack: function () {
      this.$router.push({ name: 'meetingVote', params: { mid: this.$route.params.mid } })
    },
    getCurrentUserRole: function () {
      this.$api.userInfo.getCurrentUserRole().then(data => {
        this.userRole = data
      }).catch(err => {
        return err
      })
    },
    submitStateChange: function () {
      this.listQuery.SkipCount = 0
      this.getVoteWJDetails()
    },
    refresh: function () {
      this.getVoteWJDetails()
    },
    getVoteWJDetails: function () {
      const _this = this
      const openLoading = _this.openLoading('', '.main_body')
      _this.listQuery.VoteId = _this.$route.params.qid
      voteManageApi.getVoteWJDetails(_this.listQuery).then(data => {
        _this.voteDetail = data
        _this.listTotalCount = data.TotalCount
        openLoading.close()
      }).catch(err => {
        openLoading.close()
        return err
      })
    },
    indexMethod (index) {
      return this.listQuery.SkipCount + index + 1
    },
    handleSizeChange (val) {
      this.listQuery.MaxResultCount = val
      this.getVoteWJDetails()
    },
    handleCurrentChange (val) {
      this.listQuery.SkipCount = (val - 1) * this.listQuery.MaxResultCount
      this.getVoteWJDetails()
    },
    exportData: function () {
      const openLoading = this.openLoading('正在导出…')
      voteManageApi.exportVoteWJDetails({
        VoteId: this.listQuery.VoteId,
        SubmitState: this.listQuery.SubmitState
      }).then(data => {
        if (!data) {
          return
        }
        let fileName = '投票明细'
        fileName = this.voteDetail.VoteName + ' - 投票明细'
        const fileUrl = window.URL.createObjectURL(new Blob([data], { type: 'application/vnd.ms-excel;charset=utf-8' }))

        const elink = document.createElement('a')
        // 设置下载文件名
        elink.setAttribute('download', fileName + '.xlsx')
        elink.style.display = 'none'
        elink.href = fileUrl
        document.body.appendChild(elink)
        elink.click()

        document.body.removeChild(elink) // 下载完成移除元素
        window.URL.revokeObjectURL(fileUrl) // 释放掉blob对象
        openLoading.close()
      }).catch(err => {
        openLoading.close()
        return err
      })
    },
    userTableCellClassName: function ({ row, column, rowIndex, columnIndex }) {
      if (row.IsRemove) {
        return 'vote_detail_table_cell_remove'
      } else {
        if (row.IsSubmit) {
          return 'vote_detail_table_cell_submit'
        } else {
          return 'vote_detail_table_cell_default'
        }
      }
    },
    userTableHeaderCellClassName: function ({ row, column, rowIndex, columnIndex }) {
      return 'vote_detail_table_headCell_default'
    }
  },
  computed: {

  },
  created () {
    this.getVoteWJDetails()
    this.getCurrentUserRole()
    if (this.is_xs) {
      this.pagination_layout = 'total,prev, pager, next'
    } else {
      this.pagination_layout = 'total, sizes, prev, pager, next, jumper'
    }
  }
}
</script>
<style lang="less">
.el-table thead.is-group th {
  background: none;
}

.el-table thead.is-group tr:first-of-type th:first-of-type {
  border-bottom: none;
}

.el-table thead.is-group tr:first-of-type th:first-of-type:before {
  content: '';
  position: absolute;
  width: 1px;
  height: 138px;
  top: 0;
  left: 0;
  background-color: grey;
  opacity: 0.3;
  display: block;
  transform: rotate(-73deg);
  transform-origin: top;
}

.el-table thead.is-group tr:last-of-type th:first-of-type:before {
  content: '';
  position: absolute;
  width: 1px;
  height: 138px;
  bottom: 0;
  right: 0;
  background-color: grey;
  opacity: 0.3;
  display: block;
  transform: rotate(-73deg);
  transform-origin: bottom;
}
.vote_detail_el_table--border {
  border-color: #909399 !important;
}
.vote_detail_table_headCell_remove {
  background-color: #fcbaba !important;
  border-color: #909399 !important;
}

.vote_detail_table_headCell_submit {
  background-color: #d9ecff !important;
  border-color: #909399 !important;
}

.vote_detail_table_headCell_default {
  background-color: #ffffff !important;
  border-color: #909399 !important;
}
.vote_detail_table_cell_remove {
  background-color: #fcbaba !important;
  border-color: #909399 !important;
}

.vote_detail_table_cell_submit {
  background-color: #d9ecff !important;
  border-color: #909399 !important;
}

.vote_detail_table_cell_default {
  background-color: #ffffff !important;
  border-color: #909399 !important;
}
</style>
